/**
 * Назначение: редирект с `/` на первый доступный раздел по capabilities.
 * Кто: все авторизованные сотрудники.
 * Вход: стартовый URL `/`.
 */

import { Navigate } from 'react-router-dom';
import { resolveFirstAllowedRoute } from '../../shared/access/route-resolver';
import { useAuth } from '../../shared/auth/use-auth';

/** Редирект с `/` на первый путь из `capabilities.routes_allowed` (+ `staff_admin_shell`), без хардкода `/dashboard`. */
export function StaffRootRedirect() {
  const { me } = useAuth();
  const to = resolveFirstAllowedRoute(me?.capabilities ?? null, me);
  return <Navigate to={to} replace />;
}
